module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ef4b2066ab53d4f2b3e8fc62709f9014.png";